import { render, staticRenderFns } from "./ComponentEditor.vue?vue&type=template&id=40c4b336&"
import script from "./ComponentEditor.vue?vue&type=script&lang=js&"
export * from "./ComponentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports